import {Link} from "react-router-dom";
import Paginate from "../../Paginate/Paginate";
import React from "react";
import PropTypes from "prop-types";
import MDButton from "../../MDButton";

 const JensListComponent = ({lists,deleteJens}) =>{
   JensListComponent.propTypes = {
     lists : PropTypes.any,
     deleteJens : PropTypes.any,
   }
    return (
        <div className="rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
            <div className="flex items-center justify-between px-4 py-6 md:px-6 xl:px-7.5">
                <h4 className="text-xl font-semibold text-black dark:text-white text-right">
                    لیست کالا
                </h4>
                <Link
                    to="/jens/create"
                    className="inline-flex text-sm items-center justify-center rounded-md bg-black px-2 py-3 text-center font-medium text-white hover:bg-opacity-90 lg:px-4 xl:px-6"
                >
                    افزودن کالا جدید
                </Link>
            </div>

            <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
                    <thead className="bg-gray-50 dark:bg-gray-800">
                    <tr>
                        <th scope="col"
                            className="py-3 text-xs text-gray-500 dark:text-gray-500 uppercase tracking-wider">
                            ردیف
                        </th>
                        <th scope="col"
                            className="py-3 text-xs text-gray-500 dark:text-gray-500 uppercase tracking-wider">
                            عنوان کالا
                        </th>
                      <th scope="col"
                          className="py-3 text-xs text-gray-500 dark:text-gray-500 uppercase tracking-wider">
                        کد کالا
                      </th>
                        <th scope="col"
                            className="py-3 text-xs text-gray-500 dark:text-gray-500 uppercase tracking-wider">
                            عملیات
                        </th>
                    </tr>
                    </thead>

                    <tbody className="bg-white divide-y divide-gray-200 dark:bg-gray-800 dark:divide-gray-700">
                    {lists.data.map((jens, key) => (
                        <tr key={key} className={'dark:bg-boxdark'}>
                            <td className="text-center py-4 whitespace-nowrap text-sm text-black dark:text-white">
                                {key + 1}
                            </td>
                            <td className="text-center py-4 whitespace-nowrap text-sm text-black dark:text-white">
                                {jens.title}
                            </td>
                          <td className="text-center py-4 whitespace-nowrap text-sm text-black dark:text-white">
                            {jens.jens_code}
                          </td>
                            <td className="text-center py-4 whitespace-nowrap text-sm text-black dark:text-white">
                               <div className={"gap-2 flex justify-center"}>
                                 <MDButton
                                   color={"info"}
                                   disabled
                                   className="align-middle select-none font-sans font-bold text-center uppercase transition-all disabled:opacity-50 disabled:shadow-none disabled:pointer-events-none text-xs py-3 px-6 rounded-lg bg-red text-white shadow-md shadow-gray-900/10 hover:shadow-lg hover:shadow-gray-900/20 focus:opacity-[0.85] focus:shadow-none active:opacity-[0.85] active:shadow-none"
                                   type="button"
                                 >
                                   ویرایش
                                 </MDButton>

                                 <MDButton
                                   color={"error"}
                                   onClick={() => deleteJens(jens.id)}
                                   className="align-middle select-none font-sans font-bold text-center uppercase transition-all disabled:opacity-50 disabled:shadow-none disabled:pointer-events-none text-xs py-3 px-6 rounded-lg bg-red text-white shadow-md shadow-gray-900/10 hover:shadow-lg hover:shadow-gray-900/20 focus:opacity-[0.85] focus:shadow-none active:opacity-[0.85] active:shadow-none"
                                   type="button"
                                 >
                                   حذف
                                 </MDButton>
                               </div>
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>

            <Paginate links={lists.links}/>
        </div>
    )
}

export default JensListComponent;